import React from 'react';
import { LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function TopBar() {
  return <header className="sticky top-0 z-50 border-b-2 border-celeste/40 bg-white/95 shadow-sm backdrop-blur" data-id="element-308" data-mp="232nfsn0fptzi">
      <div className="bg-primary px-3 py-2 text-center font-display text-[10px] tracking-wide text-white sm:text-xs md:text-sm" data-id="element-309" data-mp="1y4vckwucalg0">
        🇦🇷 Sistema N°1 para Acompañantes Terapéuticos en Argentina
      </div>
      <div className="mx-auto hidden max-w-5xl items-center justify-center gap-7 py-2 text-xs font-semibold text-slate-500 md:flex" data-id="element-310" data-mp="2qr6fwf9bz0gi">
        <span className="flex items-center gap-1.5" data-id="element-311" data-mp="2lvr1nm7ev2jk">
          <ZapIcon className="h-3.5 w-3.5 text-accent" data-id="element-312" data-mp="2h1mw97dsn2kl" /> Acceso en 5 minutos
        </span>
        <span className="text-celeste" data-id="element-313" data-mp="2c4d59naraiun">·</span>
        <span className="flex items-center gap-1.5" data-id="element-314" data-mp="2c1h9a4igy48u">
          <LockIcon className="h-3.5 w-3.5 text-accent" data-id="element-315" data-mp="39k0uv96yeskq" /> Pago seguro
        </span>
        <span className="text-celeste" data-id="element-316" data-mp="34rqwd4rrwk6u">·</span>
        <span className="flex items-center gap-1.5" data-id="element-317" data-mp="34qy0iyucrf3h">
          <ShieldCheckIcon className="h-3.5 w-3.5 text-accent" data-id="element-318" data-mp="24ps2pgqjsyz" /> Garantía de 7 días
        </span>
      </div>
    </header>;
}